export const nameSortfileOrFolderTable = (a, b, order) => {
    if (order === 'asc') {
        return 1
    } else {
        if (a > b) { return 1; }
        if (a < b) { return -1; }
        return 0;
    }
}